export const SEND_MOBILE = "SEND_MOBILE";
export const SEND_MOBILE_SUCCESSFUL = "SEND_MOBILE_SUCCESSFUL";
export const SEND_MOBILE_FAILED = "SEND_MOBILE_FAILED";


export const VERIFY_OTP = "VERIFY_OTP";
export const VERIFY_OTP_SUCCESSFUL = "VERIFY_OTP_SUCCESSFUL";
export const VERIFY_OTP_FAILED = "VERIFY_OTP_FAILED";


export const SEND_FORGETPASSMOBILENO = "SEND_FORGETPASSMOBILENO";
export const SEND_FORGETPASSMOBILENO_SUCCESSFUL = "SEND_FORGETPASSMOBILENO_SUCCESSFUL";
export const SEND_FORGETPASSMOBILENO_FAILED = "SEND_FORGETPASSMOBILENO_FAILED";

export const CHANGE_PASSWORD_START = "CHANGE_PASSWORD_START";
export const CHANGE_PASSWORD_SUCCESSFUL = "CHANGE_PASSWORD_SUCCESSFUL";
export const CHANGE_PASSWORD_FAILED = "CHANGE_PASSWORD_FAILED";
export const CHANGE_PASSWORD_RESET = "CHANGE_PASSWORD_RESET"


export const CHANGE_PROFILE_PASSWORD_START = "CHANGE_PROFILE_PASSWORD_START";
export const CHANGE_PROFILE_PASSWORD_SUCCESSFUL = "CHANGE_PROFILE_PASSWORD_SUCCESSFUL";
export const CHANGE_PROFILE_PASSWORD_FAILED = "CHANGE_PROFILE_PASSWORD_FAILED";
export const CHANGE_PROFILE_PASSWORD_RESET = "CHANGE_PROFILE_PASSWORD_RESET"


// TO RESET ALL ERRORS

export const RESET_VERIFYOTP_ERRORS = "RESET_VERIFYOTP_ERRORS"